import { projectEncryptData } from './project';
import { environment } from '../environments/environment';
import { projectConfig } from './config';

declare global {
  var selfEnv: string;
  var selfPc: string;
}

/**
 * Inicialización temprana de variables de entorno
 * Este archivo se ejecuta antes que app.config.ts para asegurar
 * que window.selfEnv y window.selfPc estén disponibles
 */

// console.log('Inicializando variables de entorno...');

try {
  const encryptedEnv = projectEncryptData(environment);
  const encryptedConfig = projectEncryptData(projectConfig);

  if (!encryptedEnv || !encryptedConfig) {
    // throw new Error('Error: No se pudieron encriptar las configuraciones');
  }

  window['selfEnv'] = encryptedEnv;
  window['selfPc'] = encryptedConfig;

  // console.log('✅ Variables de entorno inicializadas correctamente');
  // console.log('selfEnv configurado:', !!window['selfEnv']);
  // console.log('selfPc configurado:', !!window['selfPc']);

} catch (error) {
  // console.error('❌ Error fatal en la inicialización temprana:', error);
  throw error; // Re-lanzar el error para que se maneje en main.ts
}
